import { render, staticRenderFns } from "./addModel-recycle.vue?vue&type=template&id=4f11a237&scoped=true&"
import script from "./addModel-recycle.vue?vue&type=script&lang=js&"
export * from "./addModel-recycle.vue?vue&type=script&lang=js&"
import style0 from "./addModel-recycle.vue?vue&type=style&index=0&id=4f11a237&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11a237",
  null
  
)

export default component.exports